import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { LoadingService } from './services/loading-service.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'frontend';
  public apiUrl = environment.apiUrl;
  
  constructor(public loadingService: LoadingService) {}

  
}
